import { createClient } from "@/lib/supabase/client";
import type { BlogPostBookmark } from "../supabase/types";

export async function getBookmark(userId: string, postId: string) {
	const supabase = createClient();
	const { data, error } = await supabase
		.from("blog_post_bookmarks")
		.select("*")
		.eq("user_id", userId)
		.eq("post_id", postId);
	return { data, error };
}

export async function addBookmark(userId: string, postId: string) {
	const supabase = createClient();
	const { error } = await supabase.from("blog_post_bookmarks").insert({
		user_id: userId,
		post_id: postId,
	});
	return { error };
}

export async function deleteBookmark(userId: string, postId: string) {
	const supabase = createClient();
	const { error } = await supabase
		.from("blog_post_bookmarks")
		.delete()
		.eq("user_id", userId)
		.eq("post_id", postId);
	return { error };
}

export async function getUserBookmarks(userId: string) {
	const supabase = createClient();
	const { data, error } = await supabase
		.from("blog_post_bookmarks")
		.select("*")
		.eq("user_id", userId)
		.overrideTypes<BlogPostBookmark[]>();
	return { data, error };
}
